<template>
  <div class="pagination-container">
    <el-pagination background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="listQuery.page"
      :page-sizes="pageSizes"
      :page-size="listQuery.limit"
      :total="total"
      :layout="layout"
      ref="pagination">
    </el-pagination>
  </div>
</template>

<script>

import { pushRoute } from '@/utils/route'

export default {
  name: 'pager',
  props: {
    listQuery: {
      type: Object,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    updateType: {
      type: String,
      default: 'route'
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50, 100]
    },
    getList: {
      type: Function,
      required: true
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    pushRoute,
    handleSizeChange (val) {
      switch (this.updateType) {
        case 'route':
          this.pushRoute('limit', val)
          break
        case 'query':
          this.listQuery.limit = val
          this.listQuery.page = 1
          this.getList()
          break
      }
    },
    handleCurrentChange (val) {
      switch (this.updateType) {
        case 'route':
          this.pushRoute('page', val)
          break
        case 'query':
          this.listQuery.page = val
          this.getList()
          break
      }
    },
    update (page) {
      this.$refs.pagination.internalCurrentPage = page
    }
  }
}
</script>
